<script>
    import RecurringAssessmentMapping from "../../Models/recurringAssessmentMapping";
    import AssessmentTypeModel from "../../Models/assessmentTypeModel";
    import Loader from "../Loader.svelte";
    import {notifier} from "@beyonk/svelte-notifications";
    export let params;

    let mappingDetails;

    let dragging = false;
    let dragActive;

    function loadData(id) {
        if (!mappingDetails || id != $mappingDetails.id) {
            mappingDetails = RecurringAssessmentMapping.getStore(id);
        }
    }

    let source_assessment_type;
    let destination_assessment_type;

    let src_controls;
    let dst_controls;

    let src_dst_mapping;
    let dst_src_mapping;
    let ctrl_mapping;
    async function loadMappings(mapping) {
        if (!mapping) return;


        let source_assessment_type_data = (await AssessmentTypeModel.getAssessmentTypeStatic(mapping.details.from)).assessment_type_data;
        let destination_assessment_type_data = (await AssessmentTypeModel.getAssessmentTypeStatic(mapping.details.to)).assessment_type_data;

        source_assessment_type = await AssessmentTypeModel.flattenAssessmentType(source_assessment_type_data);
        destination_assessment_type = await AssessmentTypeModel.flattenAssessmentType(destination_assessment_type_data);

        let source_controls = {};

        for (let category of source_assessment_type.categories) {
            for (let subcategory of category.subcategories) {
                for (let control of subcategory.controls) {
                    source_controls[control.id] = control;
                }
            }
        }

        let destination_controls = {};
        for (let category of destination_assessment_type.categories) {
            for (let subcategory of category.subcategories) {
                for (let control of subcategory.controls) {
                    destination_controls[control.id] = control;
                }
            }
        }

        let forward_mapping = {};
        let reverse_mapping = {};
        let control_mappings = {};
        for (let control_map of mapping) {
            forward_mapping[control_map.details.from] = control_map.details.to;
            reverse_mapping[control_map.details.to] = control_map.details.from;
            control_mappings[control_map.details.to] = control_map
        }

        src_controls = source_controls;
        dst_controls = destination_controls;

        src_dst_mapping = forward_mapping;
        dst_src_mapping = reverse_mapping;
        ctrl_mapping = control_mappings;
    }

    function handleDragStart(evt, control) {
        evt.dataTransfer.setData('control_id', control.id);
        dragging = true;
    }

    function handleDrop(evt, control) {
        let src_control = evt.dataTransfer.getData("control_id");

        if (dst_src_mapping[control.id]) {
            notifier.danger("Cannot Map to already mapped control");
            dragging = false;
            return;
        }

        $mappingDetails.addChild({
            from: src_control,
            to: control.id
        });

        dragging = false;
    }

    function deleteMapping(control_id) {
        ctrl_mapping[control_id].delete();
    }

    function  handleDragOver(evt, control) {
        if (!dst_src_mapping[control.id]) {
            dragActive = control.id
            evt.preventDefault();
        }
    }

    $: loadData(params.id);
    $: loadMappings($mappingDetails);
</script>

<div class="container is-fluid">
    <Loader loading={!($mappingDetails && src_controls && dst_controls)}>
        <h1 class="title is-1">{$mappingDetails.details.name}</h1>
        <div class="columns">
            <div class="column scroll">
                <h2 class="title is-2">Source Assessment</h2>
                {#each source_assessment_type.categories as category (category.id)}
                    <h3 class="title is-3">{category.control_number} {category.name}</h3>
                    {#each category.subcategories as subcategory (subcategory.id)}
                        <h4 class="title is-4">{subcategory.control_number} {subcategory.name}</h4>
                        {#each subcategory.controls as control (control.id)}
                            <div class="box card is-draggable" class:has-background-light={src_dst_mapping[control.id]} draggable={!src_dst_mapping[control.id]}
                                on:dragstart={(evt) => handleDragStart(evt, control)}
                                on:dragend={(evt) => dragging = dragActive = false}
                            >
                                <div class="has-text-weight-bold">
                                    {control.control_number} {control.name}
                                </div>
                                <div>
                                    {control.text}
                                </div>
                                <div class="mapping-tags">
                                    {#if src_dst_mapping[control.id]}
                                        <div class="tags has-addons">
                                            <span class="tag is-info">{dst_controls[src_dst_mapping[control.id]].control_number} {dst_controls[src_dst_mapping[control.id]].name}</span>
                                        </div>
                                    {/if}
                                </div>
                            </div>
                        {/each}
                    {/each}
                {/each}
            </div>
            <div class="column scroll">
                <h2 class="title is-2">Destination Assessment</h2>
                {#each destination_assessment_type.categories as category (category.id)}
                    <h3 class="title is-3">{category.control_number} {category.name}</h3>
                    {#each category.subcategories as subcategory (subcategory.id)}
                        <h4 class="title is-4">{subcategory.control_number} {subcategory.name}</h4>
                        {#each subcategory.controls as control (control.id)}
                            <div class="box card" class:dragging class:dragOver={dragActive == control.id}
                                on:submit|preventDefault
                                on:drag|preventDefault
                                on:dragstart|preventDefault
                                on:dragover={(evt) => handleDragOver(evt, control)}
                                on:dragenter={(evt) => handleDragOver(evt, control)}

                                on:dragend|preventDefault={() => dragActive = false}
                                on:dragleave|preventDefault={() => dragActive = false}
                                on:drop|preventDefault={() => dragActive = false}
                                on:drop|preventDefault={(evt) => handleDrop(evt, control)}
                            >
                                <div class="has-text-weight-bold">
                                    {control.control_number} {control.name}
                                </div>
                                <div>
                                    {control.text}
                                </div>
                                <div class="mapping-tags">
                                    {#if dst_src_mapping[control.id]}
                                        <div class="tags has-addons">
                                            <span class="tag is-info">{src_controls[dst_src_mapping[control.id]].control_number} {src_controls[dst_src_mapping[control.id]].name}</span>
                                            <a class="tag is-delete" on:click={() => deleteMapping(control.id)}></a>
                                        </div>
                                    {/if}
                                </div>
                            </div>
                        {/each}
                    {/each}
                {/each}
            </div>
        </div>
    </Loader>
</div>

<style>
    .scroll {
        height: calc(100vh - 7em);
        overflow-y: auto;
    }

    .dragging * {
        pointer-events: none;
    }

    .dragOver {
        background-color: aliceblue;
    }

    .mapping-tags {
        height: 1.5em;
    }
</style>